import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "missionDetails",
  class: "mission-details"
}
const _hoisted_2 = { class: "step__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_joy_textarea = _resolveComponent("joy-textarea")!
  const _component_BriefHubStepLayout = _resolveComponent("BriefHubStepLayout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BriefHubStepLayout, null, {
      right: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTooltipsComponent), _normalizeProps(_guardReactiveProps(_ctx.currentTooltipsComponentParams)), null, 16))
            ]),
            _: 1
          })
        ], 512)
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.mission.project.title.label')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_input_text, {
            id: "mission-title",
            ref: "inputMissionTitle",
            autofocus: "",
            "data-testid": "input-brief-mission-title",
            name: "mission-title",
            type: "text",
            autocomplete: "off",
            value: _ctx.missionTitle,
            placeholder: _ctx.$msg('customer.brief.form.mission.title.placeholder'),
            min: _ctx.titleMinLength,
            max: _ctx.titleMaxLength,
            required: "",
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.missionTitle = $event)),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTooltips = 'title'))
          }, null, 8, ["value", "placeholder", "min", "max"]),
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$msg('customer.brief.form.mission.project.description.label')), 1),
          _createVNode(_component_joy_textarea, {
            ref: "inputMissionDescription",
            "auto-grow": "",
            "data-testid": "textarea-brief-mission-description",
            minlength: _ctx.descriptionMinLength,
            "minlength-label": _ctx.$msg('general.min.count', _ctx.descriptionMinLength),
            maxlength: _ctx.descriptionMaxLength,
            placeholder: _ctx.descriptionPlaceholder,
            rows: "10",
            name: "textarea-brief",
            value: _ctx.missionDescription,
            onValueChange: _ctx.handleTextareaChange,
            onJoyTextareaFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTooltips = 'description'))
          }, null, 8, ["minlength", "minlength-label", "maxlength", "placeholder", "value", "onValueChange"])
        ])
      ]),
      _: 1
    })
  ]))
}